<template>
    <div>
        <span
            class="headerCart__count"
            :class="{
                'is-large': cartItems.length > 99,
                'is-visible': cartItems.length,
            }"
        >
            <span>{{ cartItems.length }}</span>
        </span>

        <div class="headerCart__dropdown | dropdown">
            <div class="headerCart__scrollarea" data-component="Scrollbar">
                <ul class="headerCart__list">
                    <cart-header-dropdown-item
                        v-for="(item, index) in cartItems"
                        :key="index"
                        :item="item"
                        :quantity-label="quantityLabel"
                        v-on:item-remove="onRemoveItemEvent"
                        v-on:item-edit="onEditItemEvent"
                    />
                </ul>
            </div>

            <dl class="headerCartTotal | row">
                <dt class="headerCartTotal__title">{{ totalLabel }}</dt>
                <dd class="headerCartTotal__price" v-html="totalValue"></dd>
            </dl>

            <div class="headerCartCheckout">
                <button
                    class="headerCart__btn | btn btn--cta btn--full"
                    :class="{ 'btn--disabled': !cartItems.length }"
                    @click="onCheckout"
                >{{ checkoutLabel }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'domtastic'
import EventBus from '../../EventBus.vue'
import CartHeaderDropdownItem from './CartHeaderDropdownItem.vue'

export default {


    /* Settings
    --------------------------------------------------------- */

    name: 'CartHeaderDropdown',

    components: {
        CartHeaderDropdownItem,
    },

    props: {
        cartItems: { type: Array, required: true },
        totalValue: { type: String, required: true },
        quantityLabel: { type: String, required: true },
        totalLabel: { type: String, required: true },
        checkoutLabel: { type: String, required: true },
    },

    data() {
        return {
        }
    },


    /* Life Cycle
    --------------------------------------------------------- */

    created() {

    },


    mounted() {
        //
    },


    /* Data Handling
    --------------------------------------------------------- */


    computed: {
    },


    watch: {
        //
    },


    /* Methods
    --------------------------------------------------------- */

    methods: {
        onRemoveItemEvent(item) {
            this.sendDeleteRequest(item.id)
        },

        onEditItemEvent(item) {
            this.$root.$emit('cartsideform.edit', item.id)
            $(document).trigger('close-cart')
        },

        sendDeleteRequest(id) {
            const url = `/cart/${id}`

            const h = new Headers()
            h.append('X-Requested-With', 'XMLHttpRequest')
            h.append('Accept', 'application/json')

            const formData = new FormData()
            formData.append('_method', 'DELETE')
            formData.append('_token', document.querySelector('meta[name="csrf-token"]').getAttribute('content'))

            const fetchOptions = {
                headers     : h,
                method      : 'POST',
                credentials : 'same-origin',
                body        : formData,
            }

            fetch(url, fetchOptions)
                .then(r => r.json())
                .then((json) => {
                    // @todo : handle errors
                    EventBus.$emit('cart-update', json)
                })
        },

        onCheckout() {
            window.location.href = '/checkout'
        },
    },


    /* Handlers
    --------------------------------------------------------- */


}

</script>
